import { useEffect, useState } from "react";
import AddressFormModal from "../../components/Address/AddressFormModal"
import ViewAddressModal from "../../components/Address/ViewAddressModal"
import api from "../../api"

export default function SupplierAddress() {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [mode, setMode] = useState("create") // create | edit

  const fetchAddresses = async () => {
    try {
      const res = await api.get("/accounts/me/addresses/");
      setAddresses(res.data);
    } catch (err) {
      console.error("Error fetching addresses:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handleView = (address) => {
    setSelectedAddress(address);
    setIsViewModalOpen(true);
  };

  const handleEdit = (address) => {
    setSelectedAddress(address);
    setIsEditing(true);
    setIsFormModalOpen(true);
  };

  const handleCreate = () => {
    setSelectedAddress(null);
    setIsEditing(false);
    setIsFormModalOpen(true);
  };


  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">مدیریت آدرس‌ها</h1>
        <button
          onClick={handleCreate}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          افزودن آدرس جدید
        </button>
      </div>

      {loading ? (
        <p>در حال بارگذاری...</p>
      ) : (
        <div className="overflow-x-auto bg-white rounded-xl shadow">
          <table className="min-w-full text-sm text-right">
            <thead className="bg-gray-100 text-gray-600">
              <tr>
                <th className="px-4 py-3">عنوان</th>
                <th className="px-4 py-3">استان</th>
                <th className="px-4 py-3">شهر</th>
                <th className="px-4 py-3">آدرس</th>
                <th className="px-4 py-3 text-center">عملیات</th>
              </tr>
            </thead>
            <tbody>
              {addresses.map((addr) => (
                <tr key={addr.id} className="border-t">
                  <td className="px-4 py-3">{addr.title}{addr.is_default && (<span className="text-blue-600 text-[12px]"> (پیش فرض)</span>)}</td>
                  <td className="px-4 py-3">{addr.province_detail}</td>
                  <td className="px-4 py-3">{addr.city_detail}</td>
                  <td className="px-4 py-3 truncate max-w-xs">
                    {addr.address_text}
                  </td>
                  <td className="px-4 py-3 flex justify-center gap-3">
                    <button
                      onClick={() => handleView(addr)}
                      className="text-blue-600 hover:text-blue-800"
                    >
                      مشاهده
                    </button>
                    <button
                      onClick={() => handleEdit(addr)}
                      className="text-green-600 hover:text-green-800"
                    >
                      ویرایش
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {addresses.length === 0 && (
            <div className="p-6 text-center text-gray-500">
              هنوز آدرسی ثبت نشده است.
            </div>
          )}
        </div>
      )}

      {isViewModalOpen && (
        <ViewAddressModal
          address={selectedAddress}
          onClose={() => setIsViewModalOpen(false)}
        />
      )}

      {isFormModalOpen && (
        <AddressFormModal
          address={selectedAddress}
          isEditing={isEditing}
          onClose={() => setIsFormModalOpen(false)}
          onSuccess={fetchAddresses}
          address_type={'customer'}
          user={'user'}
        />
      )}
    </div>
  );
}